// import React, { useState, useEffect } from "react";
// import { Card, Spinner, Table } from "react-bootstrap";
// import axios from "axios";
// import Swal from "sweetalert2";
// import * as XLSX from "xlsx";
// import {
//   FaUser,
//   FaMobileAlt,
//   FaIdCard,
//   FaCheckCircle,
//   FaUsers,
// } from "react-icons/fa";
// import { FaUserCheck, FaExchangeAlt } from "react-icons/fa";
// import { HiOutlineChevronLeft, HiChevronRight } from "react-icons/hi";

// const API_URL = process.env.REACT_APP_API_URL;

// function UnitSQYDLedger() {
//   const [loading, setLoading] = useState(false);
//   const [tableData, setTableData] = useState([]);
//   const [searchDetails, setSearchDetails] = useState(null);
//   const [summary, setSummary] = useState(null);

//   // Pagination state
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const itemsPerPage = 10;

//   const getAuthToken = () => localStorage.getItem("token");

//   // Helper function to parse date string in various formats
//   const parseDate = (dateString) => {
//     if (!dateString) return null;

//     // If it's already a Date object
//     if (dateString instanceof Date) return dateString;

//     // Try parsing ISO format (YYYY-MM-DDTHH:mm:ss.sssZ)
//     let date = new Date(dateString);
//     if (!isNaN(date.getTime())) return date;

//     // Try parsing DD-MM-YYYY format
//     const ddmmYYYY = dateString.match(/^(\d{2})-(\d{2})-(\d{4})$/);
//     if (ddmmYYYY) {
//       return new Date(ddmmYYYY[3], ddmmYYYY[2] - 1, ddmmYYYY[1]);
//     }

//     // Try parsing YYYY-MM-DD format
//     const yyyymmdd = dateString.match(/^(\d{4})-(\d{2})-(\d{2})$/);
//     if (yyyymmdd) {
//       return new Date(yyyymmdd[1], yyyymmdd[2] - 1, yyyymmdd[3]);
//     }

//     return null;
//   };

//   // Helper function to format date with +5:30 offset and time
//   const formatDateTimeWithOffset = (dateString) => {
//     if (!dateString) return "NA";

//     const date = parseDate(dateString);
//     if (!date || isNaN(date.getTime())) return "NA";

//     // Add 5 hours and 30 minutes (UTC to IST)
//     date.setHours(date.getHours() + 5);
//     date.setMinutes(date.getMinutes() + 30);

//     // Format as DD-MM-YYYY HH:MM:SS
//     const day = String(date.getDate()).padStart(2, "0");
//     const month = String(date.getMonth() + 1).padStart(2, "0");
//     const year = date.getFullYear();
//     const hours = String(date.getHours()).padStart(2, "0");
//     const minutes = String(date.getMinutes()).padStart(2, "0");
//     const seconds = String(date.getSeconds()).padStart(2, "0");

//     return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
//   };

//   // Helper function to format date only (without time)
//   const formatDateOnly = (dateString) => {
//     if (!dateString) return "NA";

//     const date = parseDate(dateString);
//     if (!date || isNaN(date.getTime())) return "NA";

//     const day = String(date.getDate()).padStart(2, "0");
//     const month = String(date.getMonth() + 1).padStart(2, "0");
//     const year = date.getFullYear();

//     return `${day}-${month}-${year}`;
//   };

//   // Auto fetch data on component mount
//   useEffect(() => {
//     fetchData();
//   }, []);

//   const fetchData = async () => {
//     setLoading(true);
//     setTableData([]);
//     setSearchDetails(null);
//     setSummary(null);
//     setCurrentPage(1);

//     try {
//       const token = getAuthToken();
//       if (!token) {
//         Swal.fire("Error", "Please login first", "error");
//         setLoading(false);
//         return;
//       }

//       const response = await axios.get(
//         `${API_URL}/myteam-tree-with-sales-child`,
//         { headers: { Authorization: `Bearer ${token}` } },
//       );

//       console.log("API Response:", response.data);

//       if (response.data.status === "1") {
//         setSearchDetails(response.data.search_details);
//         setSummary(response.data.summary);

//         const formattedData = [];

//         if (
//           response.data.user_data?.transactions?.all_transactions?.length > 0
//         ) {
//           const sortedTransactions =
//             response.data.user_data.transactions.all_transactions;

//           sortedTransactions.forEach((transaction, index) => {
//             const oldSqyd = parseFloat(transaction.old_sqyd) || 0;
//             const newSqyd = parseFloat(transaction.new_sqyd) || 0;
//             const addedSqyd = newSqyd - oldSqyd;

//             let typeDisplay = "Buy SQYD";
//             if (transaction.entry_type === "self") {
//               typeDisplay = "Buy SQYD (Self)";
//             } else if (transaction.entry_type === "team") {
//               typeDisplay = "Buy SQYD (Team)";
//             }

//             formattedData.push({
//               srNo: index + 1,
//               project_name: transaction.project_name || "NA",
//               blockNo: "N/A",
//               unitNo: transaction.unit_no || "N/A",
//               customer_name: transaction.customer_name || "NA",
//               customer_mobile: transaction.customer_mobile || "NA",
//               child_username: transaction.child_username || "NA",
//               child_mobile: transaction.child_mobile || "NA",
//               oldSqyd: oldSqyd,
//               new_sqyd: newSqyd,
//               addedSqyd: addedSqyd,
//               lead_created_at: transaction.lead_created_at || "NA",
//               lead_updated_at: transaction.lead_updated_at || "NA",
//               lead_date: transaction.lead_date || "NA",
//               lead_status_date: transaction.lead_status_date || "NA",
//               date: transaction.date,
//               status_date: transaction.status_date,
//               levelNo: "0",
//               lead_id: transaction.lead_id || "NA",
//               type: typeDisplay,
//               transaction_type: transaction.transaction_type,
//               entry_type: transaction.entry_type,
//               unit_sqyd: transaction.plot_area || "0",
//               child_id: transaction.child_id,
//               transaction_id: transaction.transaction_id,
//             });
//           });
//         }

//         console.log("Formatted Data:", formattedData);
//         console.log("Number of transactions:", formattedData.length);

//         setTableData(formattedData);
//         setTotalPages(Math.ceil(formattedData.length / itemsPerPage) || 1);

//         if (formattedData.length === 0) {
//           // Swal.fire("No Data", "No transactions found for this user", "info");
//         }
//       } else {
//         // Swal.fire("No Data", response.data.message || "No data found", "info");
//         console.warn(response.data.message || "No data found");
//       }
//     } catch (error) {
//       console.error("Data fetch error:", error);
//       Swal.fire(
//         "Warning !!!",
//         "Sorry No Data Found Please Try Again Later.",
//         "info",
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Refresh data function
//   const handleRefresh = () => {
//     fetchData();
//   };

//   // Get current page data
//   const getCurrentPageData = () => {
//     const startIndex = (currentPage - 1) * itemsPerPage;
//     const endIndex = startIndex + itemsPerPage;
//     return tableData.slice(startIndex, endIndex);
//   };

//   const handlePageChange = (pageNumber) => {
//     if (pageNumber > 0 && pageNumber <= totalPages) {
//       setCurrentPage(pageNumber);
//     }
//   };

//   const downloadExcel = () => {
//     if (tableData.length === 0) {
//       Swal.fire("No Data", "No data available to download", "warning");
//       return;
//     }

//     const excelData = tableData.map((row, index) => ({
//       "Sr No": index + 1,
//       "Lead Date": formatDateTimeWithOffset(row.lead_created_at),
//       "Lead Approve Date": formatDateTimeWithOffset(row.lead_updated_at),
//       "Project Name": row.project_name || "NA",
//       "Block No": row.blockNo || "NA",
//       "Unit No": row.unitNo || "NA",
//       "Customer Name": row.customer_name || "NA",
//       "Customer Mobile": row.customer_mobile || "NA",
//       "Associate Name": row.child_username || "NA",
//       "Associate Mobile": row.child_mobile || "NA",
//       "Old SQYD": parseFloat(row.oldSqyd).toFixed(2),
//       "Added SQYD": parseFloat(row.addedSqyd).toFixed(2),
//       "New SQYD": parseFloat(row.new_sqyd).toFixed(2),
//       "Transaction Type": row.type || "NA",
//       "Lead ID": row.lead_id || "NA",
//     }));

//     const ws = XLSX.utils.json_to_sheet(excelData);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "Unit SQYD Ledger");
//     const fileName = `Unit_SQYD_Ledger_${searchDetails?.username || "user"}_${new Date().toISOString().split("T")[0]}.xlsx`;
//     XLSX.writeFile(wb, fileName);
//     Swal.fire("Success", "Excel file downloaded successfully!", "success");
//   };

//   return (
//     <div className="padding_15">
//       <div className="row justify-content-center">
//         <div className="col-12 col-md-12">
//           <Card>
//             <Card.Header>
//               <div className="d-flex justify-content-between align-items-center">
//                 <div className="titlepage">
//                   <h3 className="mb-0">Unit SQYD Ledger Report</h3>
//                 </div>
//                 {/* <button
//                   className="buttonpadding d-flex gap-2 border border-white btn btn-primary"
//                   onClick={handleRefresh}
//                   disabled={loading}
//                 >
//                   {loading ? (
//                     <Spinner animation="border" size="sm" />
//                   ) : (
//                     "Refresh"
//                   )}
//                 </button> */}
//               </div>
//             </Card.Header>
//             <Card.Body>
//               {/* User Info Card */}
//               {searchDetails && (
//                 <div className="row mb-3">
//                   <div className="col-12">
//                     <div className="card">
//                       <div className="card-body">
//                         <div className="row g-3 align-items-stretch">
//                           {/* User */}
//                           <div className="col-md-3">
//                             <div className="user-info-card">
//                               <div className="info-icon user-icon">
//                                 <FaUser />
//                               </div>

//                               <div className="info-content">
//                                 <div className="info-label">User</div>
//                                 <div className="info-value">
//                                   {searchDetails.username}
//                                 </div>
//                               </div>
//                             </div>
//                           </div>

//                           {/* Mobile */}
//                           <div className="col-md-3">
//                             <div className="user-info-card">
//                               <div className="info-icon mobile-icon">
//                                 <FaMobileAlt />
//                               </div>

//                               <div className="info-content">
//                                 <div className="info-label">Mobile</div>
//                                 <div className="info-value">
//                                   {searchDetails.mobile}
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
                         

//                           {/* Parent */}
//                           {searchDetails.parent_username && (
//                             <div className="col-md-6">
//                               <div className="user-info-card">
//                                 <div className="info-icon parent-icon">
//                                   <FaUsers />
//                                 </div>

//                                 <div className="info-content">
//                                   <div className="info-label">Parent</div>

//                                   <div className="info-value">
//                                     {searchDetails.parent_username}

//                                     <span className="parent-mobile">
//                                       ({searchDetails.parent_mobile})
//                                     </span>
//                                   </div>
//                                 </div>
//                               </div>
//                             </div>
//                           )}
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               )}

//               {/* Summary Cards */}
//               {/* {summary && (
//                 <div className="row mb-4 summary-cards">
//                   <div className="col-md-4 mb-3 mb-md-0">
//                     <div className="summary-card users-card">
//                       <div className="summary-icon">
//                         <FaUsers />
//                       </div>

//                       <div className="summary-content">
//                         <span>Total Users</span>
//                         <h4>{summary.total_users || 0}</h4>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="col-md-4 mb-3 mb-md-0">
//                     <div className="summary-card transaction-users-card">
//                       <div className="summary-icon">
//                         <FaUserCheck />
//                       </div>

//                       <div className="summary-content">
//                         <span>With Transactions</span>
//                         <h4>{summary.users_with_transactions || 0}</h4>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="col-md-4">
//                     <div className="summary-card total-transaction-card">
//                       <div className="summary-icon">
//                         <FaExchangeAlt />
//                       </div>

//                       <div className="summary-content">
//                         <span>Total Transactions</span>
//                         <h4>{summary.total_transactions || 0}</h4>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               )} */}

//               {/* Loading Spinner */}
//               {loading && (
//                 <div className="text-center py-5">
//                   <Spinner animation="border" variant="primary" />
//                   <p className="mt-2">Loading data...</p>
//                 </div>
//               )}

//               {/* Table Data */}
//               {!loading && tableData.length > 0 && (
//                 <>
//                   <div className="d-flex justify-content-between align-items-center mb-2">
//                     <div>
//                       Showing{" "}
//                       {Math.min(
//                         (currentPage - 1) * itemsPerPage + 1,
//                         tableData.length,
//                       )}{" "}
//                       to{" "}
//                       {Math.min(currentPage * itemsPerPage, tableData.length)}{" "}
//                       of {tableData.length} entries
//                     </div>
//                     <button
//                       className="btn btn-success btn-sm"
//                       onClick={downloadExcel}
//                     >
//                       <i className="fas fa-download me-1"></i>
//                       Download Excel
//                     </button>
//                   </div>

//                   <div className="table-responsive">
//                     <Table striped bordered hover size="sm" className="mt-3">
//                       <thead className="bg-primary text-white">
//                         <tr>
//                           <th>#</th>
//                           <th>Lead Date</th>
//                           <th>Lead Approve Date</th>
//                           <th>Project</th>
//                           <th>Block</th>
//                           <th>Unit</th>
//                           <th>Customer</th>
//                           <th>Customer Mobile</th>
//                           <th>Associate</th>
//                           <th>Associate Mobile</th>
//                           <th>Old SQYD</th>
//                           <th>Added SQYD</th>
//                           <th>New SQYD</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {getCurrentPageData().map((row, index) => {
//                           const actualIndex =
//                             (currentPage - 1) * itemsPerPage + index + 1;
//                           const addedSqyd = (
//                             parseFloat(row.new_sqyd) - parseFloat(row.oldSqyd)
//                           ).toFixed(2);

//                           return (
//                             <tr key={index}>
//                               <td>{actualIndex}</td>
//                               <td>{row.lead_date}</td>
//                               <td>
//                                 {formatDateTimeWithOffset(row.lead_status_date)}
//                               </td>
//                               <td>{row.project_name || "NA"}</td>
//                               <td>{row.blockNo || "NA"}</td>
//                               <td>{row.unitNo?.toUpperCase()}</td>
//                               <td>{row.customer_name || "NA"}</td>
//                               <td>{row.customer_mobile || "NA"}</td>
//                               <td>{row.child_username || "NA"}</td>
//                               <td>{row.child_mobile || "NA"}</td>
//                               <td className="text-end">
//                                 {parseFloat(row.oldSqyd).toFixed(2)}
//                               </td>
//                               <td className="text-end text-success">
//                                 +{addedSqyd}
//                               </td>
//                               <td className="text-end fw-bold">
//                                 {parseFloat(row.new_sqyd).toFixed(2)}
//                               </td>
//                             </tr>
//                           );
//                         })}
//                       </tbody>
//                     </Table>
//                   </div>

//                   {/* Pagination */}
//                   {totalPages > 1 && (
//                     <div className="d-flex justify-content-end mt-3">
//                       <nav>
//                         <ul className="pagination">
//                           <li
//                             className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
//                           >
//                             <button
//                               className="page-link"
//                               onClick={() => handlePageChange(currentPage - 1)}
//                               disabled={currentPage === 1}
//                             >
//                               <HiOutlineChevronLeft />
//                             </button>
//                           </li>

//                           {(() => {
//                             const pages = [];
//                             if (totalPages <= 5) {
//                               for (let i = 1; i <= totalPages; i++) {
//                                 pages.push(
//                                   <li
//                                     key={i}
//                                     className={`page-item ${i === currentPage ? "active" : ""}`}
//                                   >
//                                     <button
//                                       className="page-link"
//                                       onClick={() => handlePageChange(i)}
//                                     >
//                                       {i}
//                                     </button>
//                                   </li>,
//                                 );
//                               }
//                             } else {
//                               pages.push(
//                                 <li
//                                   key={1}
//                                   className={`page-item ${1 === currentPage ? "active" : ""}`}
//                                 >
//                                   <button
//                                     className="page-link"
//                                     onClick={() => handlePageChange(1)}
//                                   >
//                                     1
//                                   </button>
//                                 </li>,
//                               );

//                               if (currentPage > 3) {
//                                 pages.push(
//                                   <li
//                                     key="ellipsis1"
//                                     className="page-item disabled"
//                                   >
//                                     <span className="page-link">...</span>
//                                   </li>,
//                                 );
//                               }

//                               let start = Math.max(2, currentPage - 1);
//                               let end = Math.min(
//                                 totalPages - 1,
//                                 currentPage + 1,
//                               );

//                               if (currentPage <= 3) {
//                                 start = 2;
//                                 end = 4;
//                               } else if (currentPage >= totalPages - 2) {
//                                 start = totalPages - 3;
//                                 end = totalPages - 1;
//                               }

//                               for (let i = start; i <= end; i++) {
//                                 if (i > 1 && i < totalPages) {
//                                   pages.push(
//                                     <li
//                                       key={i}
//                                       className={`page-item ${i === currentPage ? "active" : ""}`}
//                                     >
//                                       <button
//                                         className="page-link"
//                                         onClick={() => handlePageChange(i)}
//                                       >
//                                         {i}
//                                       </button>
//                                     </li>,
//                                   );
//                                 }
//                               }

//                               if (currentPage < totalPages - 2) {
//                                 pages.push(
//                                   <li
//                                     key="ellipsis2"
//                                     className="page-item disabled"
//                                   >
//                                     <span className="page-link">...</span>
//                                   </li>,
//                                 );
//                               }

//                               pages.push(
//                                 <li
//                                   key={totalPages}
//                                   className={`page-item ${totalPages === currentPage ? "active" : ""}`}
//                                 >
//                                   <button
//                                     className="page-link"
//                                     onClick={() => handlePageChange(totalPages)}
//                                   >
//                                     {totalPages}
//                                   </button>
//                                 </li>,
//                               );
//                             }

//                             return pages;
//                           })()}

//                           <li
//                             className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
//                           >
//                             <button
//                               className="page-link"
//                               onClick={() => handlePageChange(currentPage + 1)}
//                               disabled={currentPage === totalPages}
//                             >
//                               <HiChevronRight />
//                             </button>
//                           </li>
//                         </ul>
//                       </nav>
//                     </div>
//                   )}
//                 </>
//               )}

//               {/* No Data Message */}
//               {!loading && tableData.length === 0 && searchDetails && (
//                 <div className="alert alert-warning text-center">
//                   No transaction data found for this user
//                 </div>
//               )}
//             </Card.Body>
//           </Card>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default UnitSQYDLedger;

import React, { useState, useEffect } from "react";
import { Card, Spinner, Table } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import {
  FaUser,
  FaMobileAlt,
  FaIdCard,
  FaCheckCircle,
  FaUsers,
} from "react-icons/fa";
import { FaUserCheck, FaExchangeAlt } from "react-icons/fa";
import { HiOutlineChevronLeft, HiChevronRight } from "react-icons/hi";

const API_URL = process.env.REACT_APP_API_URL;

function UnitSQYDLedger() {
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [searchDetails, setSearchDetails] = useState(null);
  const [summary, setSummary] = useState(null);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const itemsPerPage = 10;

  const getAuthToken = () => localStorage.getItem("token");

  // Helper function to parse date string in various formats
  const parseDate = (dateString) => {
    if (!dateString) return null;

    if (dateString instanceof Date) return dateString;

    let date = new Date(dateString);
    if (!isNaN(date.getTime())) return date;

    const ddmmYYYY = dateString.match(/^(\d{2})-(\d{2})-(\d{4})$/);
    if (ddmmYYYY) {
      return new Date(ddmmYYYY[3], ddmmYYYY[2] - 1, ddmmYYYY[1]);
    }

    const yyyymmdd = dateString.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (yyyymmdd) {
      return new Date(yyyymmdd[1], yyyymmdd[2] - 1, yyyymmdd[3]);
    }

    return null;
  };

  // Helper function to format date with +5:30 offset and time
  const formatDateTimeWithOffset = (dateString) => {
    if (!dateString) return "NA";

    const date = parseDate(dateString);
    if (!date || isNaN(date.getTime())) return "NA";

    date.setHours(date.getHours() + 5);
    date.setMinutes(date.getMinutes() + 30);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };

  // Helper function to format date only (without time)
  const formatDateOnly = (dateString) => {
    if (!dateString) return "NA";

    const date = parseDate(dateString);
    if (!date || isNaN(date.getTime())) return "NA";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  // Auto fetch data on component mount
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    setTableData([]);
    setSearchDetails(null);
    setSummary(null);
    setCurrentPage(1);

    try {
      const token = getAuthToken();
      if (!token) {
        console.warn("Please login first");
        setLoading(false);
        return;
      }

      const response = await axios.get(
        `${API_URL}/myteam-tree-with-sales-child`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      console.log("API Response:", response.data);

      if (response.data.status === "1") {
        setSearchDetails(response.data.search_details);
        setSummary(response.data.summary);

        const formattedData = [];

        if (
          response.data.user_data?.transactions?.all_transactions?.length > 0
        ) {
          const sortedTransactions =
            response.data.user_data.transactions.all_transactions;

          sortedTransactions.forEach((transaction, index) => {
            const oldSqyd = parseFloat(transaction.old_sqyd) || 0;
            const newSqyd = parseFloat(transaction.new_sqyd) || 0;
            const addedSqyd = newSqyd - oldSqyd;

            let typeDisplay = "Buy SQYD";
            if (transaction.entry_type === "self") {
              typeDisplay = "Buy SQYD (Self)";
            } else if (transaction.entry_type === "team") {
              typeDisplay = "Buy SQYD (Team)";
            }

            formattedData.push({
              srNo: index + 1,
              project_name: transaction.project_name || "NA",
              blockNo: "N/A",
              unitNo: transaction.unit_no || "N/A",
              customer_name: transaction.customer_name || "NA",
              customer_mobile: transaction.customer_mobile || "NA",
              child_username: transaction.child_username || "NA",
              child_mobile: transaction.child_mobile || "NA",
              oldSqyd: oldSqyd,
              new_sqyd: newSqyd,
              addedSqyd: addedSqyd,
              lead_created_at: transaction.lead_created_at || "NA",
              lead_updated_at: transaction.lead_updated_at || "NA",
              lead_date: transaction.lead_date || "NA",
              lead_status_date: transaction.lead_status_date || "NA",
              date: transaction.date,
              status_date: transaction.status_date,
              levelNo: "0",
              lead_id: transaction.lead_id || "NA",
              type: typeDisplay,
              transaction_type: transaction.transaction_type,
              entry_type: transaction.entry_type,
              unit_sqyd: transaction.plot_area || "0",
              child_id: transaction.child_id,
              transaction_id: transaction.transaction_id,
            });
          });
        }

        console.log("Formatted Data:", formattedData);
        console.log("Number of transactions:", formattedData.length);

        setTableData(formattedData);
        setTotalPages(Math.ceil(formattedData.length / itemsPerPage) || 1);
      } else {
        console.warn(response.data.message || "No data found");
      }
    } catch (error) {
      console.error("Data fetch error:", error);
      // ✅ No alert — table me "No data available" show hoga
    } finally {
      setLoading(false);
    }
  };

  // Refresh data function
  const handleRefresh = () => {
    fetchData();
  };

  // Get current page data
  const getCurrentPageData = () => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return tableData.slice(startIndex, endIndex);
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const downloadExcel = () => {
    if (tableData.length === 0) {
      Swal.fire("No Data", "No data available to download", "warning");
      return;
    }

    const excelData = tableData.map((row, index) => ({
      "Sr No": index + 1,
      "Lead Date": formatDateTimeWithOffset(row.lead_created_at),
      "Lead Approve Date": formatDateTimeWithOffset(row.lead_updated_at),
      "Project Name": row.project_name || "NA",
      "Block No": row.blockNo || "NA",
      "Unit No": row.unitNo || "NA",
      "Customer Name": row.customer_name || "NA",
      "Customer Mobile": row.customer_mobile || "NA",
      "Associate Name": row.child_username || "NA",
      "Associate Mobile": row.child_mobile || "NA",
      "Old SQYD": parseFloat(row.oldSqyd).toFixed(2),
      "Added SQYD": parseFloat(row.addedSqyd).toFixed(2),
      "New SQYD": parseFloat(row.new_sqyd).toFixed(2),
      "Transaction Type": row.type || "NA",
      "Lead ID": row.lead_id || "NA",
    }));

    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Unit SQYD Ledger");
    const fileName = `Unit_SQYD_Ledger_${
      searchDetails?.username || "user"
    }_${new Date().toISOString().split("T")[0]}.xlsx`;
    XLSX.writeFile(wb, fileName);
    Swal.fire("Success", "Excel file downloaded successfully!", "success");
  };

  return (
    <div className="padding_15">
      <div className="row justify-content-center">
        <div className="col-12 col-md-12">
          <Card>
            <Card.Header>
              <div className="d-flex justify-content-between align-items-center">
                <div className="titlepage">
                  <h3 className="mb-0">Unit SQYD Ledger Report</h3>
                </div>
              </div>
            </Card.Header>
            <Card.Body>
              {/* User Info Card */}
              {searchDetails && (
                <div className="row mb-3">
                  <div className="col-12">
                    <div className="card">
                      <div className="card-body">
                        <div className="row g-3 align-items-stretch">
                          {/* User */}
                          <div className="col-md-3">
                            <div className="user-info-card">
                              <div className="info-icon user-icon">
                                <FaUser />
                              </div>

                              <div className="info-content">
                                <div className="info-label">User</div>
                                <div className="info-value">
                                  {searchDetails.username}
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Mobile */}
                          <div className="col-md-3">
                            <div className="user-info-card">
                              <div className="info-icon mobile-icon">
                                <FaMobileAlt />
                              </div>

                              <div className="info-content">
                                <div className="info-label">Mobile</div>
                                <div className="info-value">
                                  {searchDetails.mobile}
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Parent */}
                          {searchDetails.parent_username && (
                            <div className="col-md-6">
                              <div className="user-info-card">
                                <div className="info-icon parent-icon">
                                  <FaUsers />
                                </div>

                                <div className="info-content">
                                  <div className="info-label">Parent</div>

                                  <div className="info-value">
                                    {searchDetails.parent_username}

                                    <span className="parent-mobile">
                                      ({searchDetails.parent_mobile})
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Loading Spinner */}
              {loading && (
                <div className="text-center py-5">
                  <Spinner animation="border" variant="primary" />
                  <p className="mt-2">Loading data...</p>
                </div>
              )}

              {/* ✅ Table — always visible when not loading */}
              {!loading && (
                <>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <div>
                      {tableData.length > 0 ? (
                        <>
                          Showing{" "}
                          {Math.min(
                            (currentPage - 1) * itemsPerPage + 1,
                            tableData.length
                          )}{" "}
                          to{" "}
                          {Math.min(
                            currentPage * itemsPerPage,
                            tableData.length
                          )}{" "}
                          of {tableData.length} entries
                        </>
                      ) : (
                        "No entries found"
                      )}
                    </div>

                    {tableData.length > 0 && (
                      <button
                        className="btn btn-success btn-sm"
                        onClick={downloadExcel}
                      >
                        <i className="fas fa-download me-1"></i>
                        Download Excel
                      </button>
                    )}
                  </div>

                  <div className="table-responsive">
                    <Table
                      striped
                      bordered
                      hover
                      size="sm"
                      className="mt-3"
                    >
                      <thead className="bg-primary text-white">
                        <tr>
                          <th>#</th>
                          <th>Lead Date</th>
                          <th>Lead Approve Date</th>
                          <th>Project</th>
                          <th>Block</th>
                          <th>Unit</th>
                          <th>Customer</th>
                          <th>Customer Mobile</th>
                          <th>Associate</th>
                          <th>Associate Mobile</th>
                          <th>Old SQYD</th>
                          <th>Added SQYD</th>
                          <th>New SQYD</th>
                        </tr>
                      </thead>

                      <tbody>
                        {tableData.length > 0 ? (
                          getCurrentPageData().map((row, index) => {
                            const actualIndex =
                              (currentPage - 1) * itemsPerPage + index + 1;
                            const addedSqyd = (
                              parseFloat(row.new_sqyd) -
                              parseFloat(row.oldSqyd)
                            ).toFixed(2);

                            return (
                              <tr key={index}>
                                <td>{actualIndex}</td>
                                <td>{row.lead_date}</td>
                                <td>
                                  {formatDateTimeWithOffset(
                                    row.lead_status_date
                                  )}
                                </td>
                                <td>{row.project_name || "NA"}</td>
                                <td>{row.blockNo || "NA"}</td>
                                <td>{row.unitNo?.toUpperCase()}</td>
                                <td>{row.customer_name || "NA"}</td>
                                <td>{row.customer_mobile || "NA"}</td>
                                <td>{row.child_username || "NA"}</td>
                                <td>{row.child_mobile || "NA"}</td>
                                <td className="text-end">
                                  {parseFloat(row.oldSqyd).toFixed(2)}
                                </td>
                                <td className="text-end text-success">
                                  +{addedSqyd}
                                </td>
                                <td className="text-end fw-bold">
                                  {parseFloat(row.new_sqyd).toFixed(2)}
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td
                              colSpan="13"
                              style={{
                                textAlign: "center",
                                padding: "30px 10px",
                                color: "#64748b",
                                fontWeight: "500",
                                background: "#f8fafc",
                              }}
                            >
                              No data available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>

                  {/* Pagination — only when data exists */}
                  {tableData.length > 0 && totalPages > 1 && (
                    <div className="d-flex justify-content-end mt-3">
                      <nav>
                        <ul className="pagination">
                          <li
                            className={`page-item ${
                              currentPage === 1 ? "disabled" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() =>
                                handlePageChange(currentPage - 1)
                              }
                              disabled={currentPage === 1}
                            >
                              <HiOutlineChevronLeft />
                            </button>
                          </li>

                          {(() => {
                            const pages = [];
                            if (totalPages <= 5) {
                              for (let i = 1; i <= totalPages; i++) {
                                pages.push(
                                  <li
                                    key={i}
                                    className={`page-item ${
                                      i === currentPage ? "active" : ""
                                    }`}
                                  >
                                    <button
                                      className="page-link"
                                      onClick={() => handlePageChange(i)}
                                    >
                                      {i}
                                    </button>
                                  </li>
                                );
                              }
                            } else {
                              pages.push(
                                <li
                                  key={1}
                                  className={`page-item ${
                                    1 === currentPage ? "active" : ""
                                  }`}
                                >
                                  <button
                                    className="page-link"
                                    onClick={() => handlePageChange(1)}
                                  >
                                    1
                                  </button>
                                </li>
                              );

                              if (currentPage > 3) {
                                pages.push(
                                  <li
                                    key="ellipsis1"
                                    className="page-item disabled"
                                  >
                                    <span className="page-link">...</span>
                                  </li>
                                );
                              }

                              let start = Math.max(2, currentPage - 1);
                              let end = Math.min(
                                totalPages - 1,
                                currentPage + 1
                              );

                              if (currentPage <= 3) {
                                start = 2;
                                end = 4;
                              } else if (currentPage >= totalPages - 2) {
                                start = totalPages - 3;
                                end = totalPages - 1;
                              }

                              for (let i = start; i <= end; i++) {
                                if (i > 1 && i < totalPages) {
                                  pages.push(
                                    <li
                                      key={i}
                                      className={`page-item ${
                                        i === currentPage ? "active" : ""
                                      }`}
                                    >
                                      <button
                                        className="page-link"
                                        onClick={() => handlePageChange(i)}
                                      >
                                        {i}
                                      </button>
                                    </li>
                                  );
                                }
                              }

                              if (currentPage < totalPages - 2) {
                                pages.push(
                                  <li
                                    key="ellipsis2"
                                    className="page-item disabled"
                                  >
                                    <span className="page-link">...</span>
                                  </li>
                                );
                              }

                              pages.push(
                                <li
                                  key={totalPages}
                                  className={`page-item ${
                                    totalPages === currentPage
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  <button
                                    className="page-link"
                                    onClick={() =>
                                      handlePageChange(totalPages)
                                    }
                                  >
                                    {totalPages}
                                  </button>
                                </li>
                              );
                            }

                            return pages;
                          })()}

                          <li
                            className={`page-item ${
                              currentPage === totalPages ? "disabled" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() =>
                                handlePageChange(currentPage + 1)
                              }
                              disabled={currentPage === totalPages}
                            >
                              <HiChevronRight />
                            </button>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  )}
                </>
              )}
            </Card.Body>
          </Card>
        </div>
      </div>
    </div>
  );
}

export default UnitSQYDLedger;
